import React from "react";

const PersonProfile = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        // height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <p
        style={{
          color: "#570de6",
          textAlign: "center",
          fontSize: "20px",
          fontWeight: "700",
        }}
      >
        Feature Coming Soon...
      </p>
    </div>
  );
};

export default PersonProfile;
